import { VersionUpdateNotifier } from 'v5/features/core/version-update-notifier/VersionUpdateNotifier';
import { myToastService } from 'v5/services/front/ToastService/ToastService.connected';

export function VersionUpdateNotifierWidget() {
  return <VersionUpdateNotifier services={{ toastService: myToastService }} />;
}
